import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddressBook = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.2 12.3C15.3 11.6 16 10.4 16 9C16 6.8 14.2 5 12 5C9.8 5 8 6.8 8 9C8 10.4 8.7 11.6 9.8 12.3C7.6 13 6 14.6 6 16.5C6 16.8 6.2 17 6.5 17C6.8 17 7 16.8 7 16.5C7 14.6 9.2 13 12 13C14.8 13 17 14.6 17 16.5C17 16.8 17.2 17 17.5 17C17.8 17 18 16.8 18 16.5C18 14.6 16.4 13 14.2 12.3ZM12 12C10.3 12 9 10.7 9 9C9 7.3 10.3 6 12 6C13.7 6 15 7.3 15 9C15 10.7 13.7 12 12 12Z",
		fill: "#F5F4F3"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.5 1C19.7 1 20 1.3 20 1.5V22.5C20 22.7 19.7 23 19.5 23H4.5C4.3 23 4 22.7 4 22.5V1.5C4 1.3 4.3 1 4.5 1H19.5ZM19.5 0H4.5C3.7 0 3 0.7 3 1.5V3H2.5C2.2 3 2 3.2 2 3.5C2 3.8 2.2 4 2.5 4H3V6H2.5C2.2 6 2 6.2 2 6.5C2 6.8 2.2 7 2.5 7H3V9H2.5C2.2 9 2 9.2 2 9.5C2 9.8 2.2 10 2.5 10H3V12H2.5C2.2 12 2 12.2 2 12.5C2 12.8 2.2 13 2.5 13H3V15H2.5C2.2 15 2 15.2 2 15.5C2 15.8 2.2 16 2.5 16H3V18H2.5C2.2 18 2 18.2 2 18.5C2 18.8 2.2 19 2.5 19H3V21H2.5C2.2 21 2 21.2 2 21.5C2 21.8 2.2 22 2.5 22H3V22.5C3 23.3 3.7 24 4.5 24H19.5C20.3 24 21 23.3 21 22.5V1.5C21 0.7 20.3 0 19.5 0Z",
		fill: "#F5F4F3"
	})]
});
export default SvgAddressBook;
